export default __webpack_public_path__ + "static/media/w-logo.d976b79c.png";